import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, map, of } from 'rxjs';
import {
    DynamicProductParam,
    Product,
    ProductRepository,
} from 'src-ironside/repositories/product.repository';
import { Resource, ResourceRepository } from 'src-ironside/repositories/resource.repository';

@Component({
    selector: 'app-list-product',
    templateUrl: 'list-Product.component.html',
    styleUrls: ['./list-Product.component.css'],
    providers: [ProductRepository, ResourceRepository],
})
export class ListProductComponent implements OnChanges {
    @Input() productDetail: Product;
    listProductNews: Product[] = [];
    responsiveOptions!: any[];
    loading: boolean = false;
    param: string;
    constructor(
        private productRepository: ProductRepository,
        private resourceRepository: ResourceRepository,
        private router: Router,
        private route: ActivatedRoute
    ) {
        this.param = this.route.snapshot.params['id'];
    }

    ngOnInit(): void {}

    ngOnChanges(changes: SimpleChanges): void {
        this.fetchMostViewedProducts();
    }

    fetchMostViewedProducts() {
        this.loading = true;
        const filters = [
            {
                fieldName: 'categoryCode',
                conditions: [
                    {
                        type: 'EQUALS',
                        value: this.productDetail?.categoryCode,
                    },
                ],
            },
        ];

        const body: DynamicProductParam = {
            fields: [
                'id',
                'longDescription',
                'shortDescription',
                'brand',
                'packaging',
                'standardNumberNf',
                'state',
                'linkToTariff',
                'linkToRessources',
                'referenceProduct',
                'linkToParentProduct',
                'statusProduct',
            ],
            filters: filters,
            page: 1,
            pageSize: 20,
        };

        this.productRepository
            .getMostViewedProduct(body)
            .pipe(map((res) => this.fetchImageProduct(res)))
            .subscribe({
                next: (res) => {
                    this.listProductNews = res.filter((el) => el.statusProduct?.value == 'VALIDE');
                    this.loading = false;

                    this.productRepository
                        .loadFullExtendDataByGroup(this.listProductNews, false)
                        .subscribe({
                            next: (res) => {
                                this.listProductNews =
                                    res?.filter((el) => el.referenceProduct != this.param) ?? [];
                            },
                            error: (error) => {
                                console.error('Error loading product data:', error);
                            },
                        });
                },
                error: () => {
                    this.loading = false;
                },
            });
    }

    fetchImageProduct(products: Product[]) {
        const productGroups = [];

        for (let i = 0; i < products.length; i += 10) {
            productGroups.push(products.slice(i, i + 10));
        }

        const observables = productGroups.map((group) => {
            const resourceIds = group.flatMap((product) => product.resources || []);
            return resourceIds.length
                ? this.resourceRepository.getListImageResource(resourceIds)
                : of([]);
        });

        forkJoin(observables).subscribe((results) => {
            const combinedImages = results.flatMap((item) => item);

            products.forEach((product) => {
                const matchingImage: Resource | undefined = combinedImages.find(
                    (image) => image?.id === product?.resources?.[0]
                );

                if (matchingImage) {
                    product.image = matchingImage?.files?.[0]?.url || '';
                }
            });
        });
        return products;
    }

    onRedirecProductDetailByProduct(id: string) {
        this.router.navigateByUrl(`product/detail/${id}`);
    }

    getResourceValid(value: any) {
        if (Array.isArray(value) && value.length) {
            const result = value.flatMap((el: any) => {
                return (
                    el?.resources?.filter(
                        (item: any) => item?.files && item.typeOfResource === 'PHOTO'
                    ) || []
                );
            });
            return result.length
                ? result?.[0]?.files?.[0]?.thumbnailUrl
                : 'src-ironside/assets/images/image-default.jpg';
        } else {
            return 'src-ironside/assets/images/image-default.jpg';
        }
    }
}
